import { AnalyticsContext } from '@carvana/eventable-clickstream';
import { useEffectOnce } from '@carvana/merch-react-hooks';
import { useContext } from 'react';
import { useIsLoggedIn } from '~/context/common/UserContext';
import useSoftPullStatus from '~/hooks/vdp/selectors/useSoftPullStatus';

export default function useSendSoftPull() {
  const { trackEvent } = useContext(AnalyticsContext);
  const { softPullStatus, isLoaded } = useSoftPullStatus();
  const isLoggedIn = useIsLoggedIn();
  const isLoggedInAndFinancingLoaded = isLoggedIn && isLoaded;

  // We only care what the user's soft pull status is when they arrive at the page.
  useEffectOnce(
    () => {
      trackEvent('Soft Pull', { softPullStatus });
    },
    [softPullStatus, trackEvent],
    isLoggedInAndFinancingLoaded
  );
}
